/**
 * Author:hong.rong
 * Desc:埋点公共工具类
 * Date:2022-07-11
 */

import { getLoginStatus } from '@/utils'
import { userActionAdd } from '@/services/common'

/**
 * 埋点所需的用户行为类型
 */
export const ACTION_TYPE = {
  USER_LOGIN: 'USER_LOGIN', // 登录
  USER_TEMPLATE_MAKE: 'USER_TEMPLATE_MAKE', // 模板制作
  USER_MATERIAL_LOOK: 'USER_MATERIAL_LOOK', // 素材查看
  USER_MATERIAL_SHARE: 'USER_MATERIAL_SHARE', // 素材分享
  USER_MATERIAL_DOWNLOAD: 'USER_MATERIAL_DOWNLOAD', // 素材下载
  USER_MATERIAL_COLLECT: 'USER_MATERIAL_COLLECT', // 素材收藏
  USER_MATERIAL_CANCEL_COLLECT: 'USER_MATERIAL_CANCEL_COLLECT', // 素材取消收藏
  DEMAND_INDEX_TAB_CLICK: 'DEMAND_INDEX_TAB_CLICK', // 顶导tab
  VIDEO_TEMPLATE_SEARCH: 'VIDEO_TEMPLATE_SEARCH', // 视频列表页关键词搜索
  IMAGE_TEMPLATE_SEARCH: 'IMAGE_TEMPLATE_SEARCH', // 图片列表页关键词搜索
  VIDEO_TEMPLATE_SEARCH_TAB_CLICK: 'VIDEO_TEMPLATE_SEARCH_TAB_CLICK', // 视频分类tab点击
  IMAGE_TEMPLATE_SEARCH_TAB_CLICK: 'IMAGE_TEMPLATE_SEARCH_TAB_CLICK', // 图片分类tab点击
  VIDEO_TEMPLATE_SEARCH_OPTIONS_CLICK: 'VIDEO_TEMPLATE_SEARCH_OPTIONS_CLICK', // 视频搜索分类选项点击
  IMAGE_TEMPLATE_SEARCH_OPTIONS_CLICK: 'IMAGE_TEMPLATE_SEARCH_OPTIONS_CLICK', // 图片搜索分类选项点击
  VIDEO_TEMPLATE_SEARCH_VIDEO_TYPE_CLICK: 'VIDEO_TEMPLATE_SEARCH_VIDEO_TYPE_CLICK', // 视频搜索 套版/拼接 选项点击
  VIDEO_TEMPLATE_SEARCH_SORT_CLICK: 'VIDEO_TEMPLATE_SEARCH_SORT_CLICK', // 视频搜索排序点击
  IMAGE_TEMPLATE_SEARCH_SORT_CLICK: 'IMAGE_TEMPLATE_SEARCH_SORT_CLICK', // 图片搜索排序点击
  TEMPLATE_LIST_ITEM_CLICK: 'TEMPLATE_LIST_ITEM_CLICK', // 模板列表结果点击
  TEMPLATE_LIST_FAV_CLICK: 'TEMPLATE_LIST_FAV_CLICK', // 列表界面收藏按钮点击
  TEMPLATE_LIST_PLAY_CLICK: 'TEMPLATE_LIST_PLAY_CLICK', // 列表界面播放按钮点击
  TEMPLATE_WIN_FAV_CLICK: 'TEMPLATE_WIN_FAV_CLICK', // 素材详情弹窗收藏按钮点击
  TEMPLATE_WIN_SHOW: 'TEMPLATE_WIN_SHOW', // 素材详情弹窗展示
  TEMPLATE_WIN_CLICK: 'TEMPLATE_WIN_CLICK', // 素材详情弹窗点击
  VE_TEMPLATE_IMPL_LEFT_TAB_CLICK: 'VE_TEMPLATE_IMPL_LEFT_TAB_CLICK', // VE制作页左侧tab点击
  KV_TEMPLATE_IMPL_LEFT_TAB_CLICK: 'KV_TEMPLATE_IMPL_LEFT_TAB_CLICK', // 可画制作页左侧tab点击
  VE_TEMPLATE_IMPL_DRAFT_SAVE_CLICK: 'VE_TEMPLATE_IMPL_DRAFT_SAVE_CLICK', // VE制作页草稿保存按钮点击
  VE_TEMPLATE_IMPL_MAKE_CLICK: 'VE_TEMPLATE_IMPL_MAKE_CLICK', // VE制作页生成作品按钮点击
  KV_TEMPLATE_IMPL_DRAFT_CLICK: 'KV_TEMPLATE_IMPL_DRAFT_CLICK', // 可画制作页保存按钮点击
  KV_TEMPLATE_IMPL_MAKE_CLICK: 'KV_TEMPLATE_IMPL_MAKE_CLICK', // 可画制作页导出按钮点击
  VE_TEMPLATE_IMPL_TPL_SEARCH: 'VE_TEMPLATE_IMPL_TPL_SEARCH', // VE制作页模板搜索
  VE_TEMPLATE_IMPL_DIR_SEARCH: 'VE_TEMPLATE_IMPL_DIR_SEARCH', // VE制作页素材目录搜索
  KV_TEMPLATE_IMPL_TPL_SEARCH: 'KV_TEMPLATE_IMPL_TPL_SEARCH', // 可画制作页模板搜索
  WORK_DOWNLOAD: 'WORK_DOWNLOAD', // 作品下载
  VE_TEMPLATE_IMAGE_VIDEO_NUMBER_SEARCH: 'VE_TEMPLATE_IMAGE_VIDEO_NUMBER_SEARCH', // VE视频模板展示可改图数搜索
  VE_TEMPLATE_TEXT_NUMBER_SEARCH: 'VE_TEMPLATE_TEXT_NUMBER_SEARCH', // VE视频模板展示可改文数搜索
  WORK_KEYWORD_SEARCH: 'WORK_KEYWORD_SEARCH', // 作品列表页作品名称/作者/订单号/客户产品搜索
  DATA_CENTER_OPEN: 'DATA_CENTER_OPEN', // 用户点击数据中心入口
  DATA_CENTER_DETAIL_CLICK: 'DATA_CENTER_DETAIL_CLICK', // 用户数据点击详情页
  DATA_CENTER_DETAIL_OPEN: 'DATA_CENTER_DETAIL_OPEN', // 用户详情页打开完成
  DISTRIBUTE_WORKS_FROM_MEDIA_CENTER: 'DISTRIBUTE_WORKS_FROM_MEDIA_CENTER', // 作品分发来源媒体中心
  DISTRIBUTE_WORKS_FROM_WORK_LIBRARY: 'DISTRIBUTE_WORKS_FROM_WORK_LIBRARY', // 作品分发来作品库
  TEMPLATE_SEARCH_OPTIONS_CLICK: 'TEMPLATE_SEARCH_OPTIONS_CLICK', // 创意制作来源列表筛选行业-品类
  CASE_SEARCH_OPTIONS_CLICK: 'CASE_SEARCH_OPTIONS_CLICK', // 案例搜索分类选项点击
  CASE_LIST_SHOW: 'CASE_LIST_SHOW', // 案例列表浏览
  TEMPLATE_LIST_SHOW: 'TEMPLATE_LIST_SHOW', // 模板列表浏览
}

/**
 * 用户埋点公共方法
 * @param params
 * @returns {Promise<any>}
 */
export function userActionRecord(params = {}) {
  if (getLoginStatus()) {
    try {
      // 登录状态下埋点
      userActionAdd(params).then(() => {})
    } catch (error) {
      console.error(error)
    }
  }
}
